// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: rgb(115, 92, 173);
  --color-primary-input-border: #b2a6cf;
  --color-primary-hover:#6549ac;
  --color-primaryxxx-hover:#9080ba;
  --color-primary-light:#f4f0ff;
  --font-primary: "Poppins", sans-serif;
}

.droddown-hover-button:hover{
  background-color: #e6defc;
}

.primary-bg{
  background-color: var(--color-primary);
  color: white;
}
.primary-text{
  color: var(--color-primary);
}
.primary-bg:hover{
  background-color: var(--color-primary-hover);
}
.primary-bg-common{
  background-color: var(--color-primary-light);
}

.tab-bg-primary{
  background-color: #e4def5;
}


body {
  font-family: "PT Sans", sans-serif;
  font-weight: 400;
  font-style: normal;
  margin: 0;
  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

  /* Splash screen */

  /* .loader-2{
    width : 35px;
    height: 35px;
    border-radius: 50%;
    display: inline-block;
    border-top:3px solid var(--color-primary);
    border-right:3px solid transparent;
    animation: rotation 1s linear infinite;
  } */

  /* @keyframes rotation {
    0% { transform: rotate(0deg) }
    100% { transform: rotate(360deg) }
  } */


  .loader{
    width: 300px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding-top: 100px; */
    margin: 0 auto;
  }

  .dot {
    background: var(--color-primary);
    margin: 5px;
    animation-name: loader;
    animation-duration: 1s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }
  
  .dot:nth-child(1) {
    animation-delay: 0.2s;
  }
  .dot:nth-child(2) {
    animation-delay: 0.4s;
  }
  .dot:nth-child(3) {
    animation-delay: 0.6s;
  }
  .dot:nth-child(4) {
    animation-delay: 0.8s;
  }
  .dot:nth-child(5) {
    animation-delay: 1s;
  }
  
  @keyframes loader {
    from {
      width: 2px;
      height: 2px;
      border-radius: calc(2px / 2);
    }
    to {
      width: 10px;
      height: 10px;
      border-radius: calc(20px / 2);
    }
  }
  @keyframes zoom-in {
    from {
      transform: scale(0.5);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
  .modal-design{
    position: relative;
    padding: 0;
    outline: none;
    border-radius: 6px;
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.3);
    background-color: #f7f7f7;
    animation: zoom-in 0.5s ease-out;
}

@media (max-width: 450px){
  .modal-design{
    width: 80vw;
    
  }
}

/* generic Modal */

.header-part{
  border-bottom: 1.5px solid black;
  padding-bottom: 2px;
}

/* form */
.form-style{
  box-shadow: 10px 2px 5px 22px rgb(212, 212, 212);
}


.switch-field {
  display: flex;
  overflow: hidden;
}

.switch-field input {
  position: absolute !important;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  width: 1px;
  border: 0;
  overflow: hidden;
}

.switch-field label {
  background-color: #e4e4e4;
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 1;
  text-align: center;
  padding: 8px 14px;
  margin-right: -1px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);
  transition: all 0.1s ease-in-out;
}

.switch-field label:hover {
  cursor: pointer;
}

.switch-field input:checked + label {
  background-color: var(--color-primary);
  color: white;
  box-shadow: none;
}

.switch-field label:first-of-type {
  border-radius: 4px 0 0 4px;
}

.switch-field label:last-of-type {
  border-radius: 0 4px 4px 0;
}

/* input field */
/* 
 text-sm  mx-8 my-4 */
#register input, .common-input-field, #login input, #forgotPassword input {
  outline: 2px solid var(--color-primary-input-border) ;
  color: rgb(59, 59, 59);
  background-color: rgb(240, 239, 239);
  border-radius: 5px;
  padding: 6px 8px;
}
#register input:focus, .common-input-field:focus, #login input:focus, #forgotPassword input:focus{
  outline: 2px solid var(--color-primary) ;/* Add focus ring */
}

.ReactModal__Overlay--after-open{
background-color:rgba(0, 0, 0, 0.75)!important;
display: flex;
z-index: 100;
}

.ReactModal__Content--after-open{
  border-radius: 10px;
}

@keyframes slide-left {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.modal-menu{
  position: relative;
  padding: 0;

  /* border-radius: 6px; */
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  outline: none;
  background-color: #f7f7f7;
  animation: slide-left 0.3s ease-out;
}
.cart-menu{
  position: absolute;
  right: 0;
  padding: 0;

  /* border-radius: 6px; */
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  outline: none;
  background-color: #f7f7f7;
  animation: slide-left 0.3s ease-out;
}

.no-scroll {
  overflow: hidden;
}

.slick-prev:before, .slick-next:before {
  font-size: 30px!important;
  color: rgb(145, 145, 145)!important;
}

@media(max-width: 500px){
  .slick-prev:before, .slick-next:before {
    font-size: 24px!important;
    color: rgb(145, 145, 145)!important;
  }
}


/* Styles for WebKit browsers (Chrome, Safari, Edge) */
::-webkit-scrollbar {
  width: 12px; /* Width of the scrollbar */
  height: 12px; /* Height of the scrollbar */
}

::-webkit-scrollbar-thumb {
  background-color: #888; /* Color of the scrollbar thumb */
  border-radius: 6px; /* Rounded corners */
  border: 3px solid #fff; /* Padding around thumb */
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* Color when hovered */
}

::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background of the scrollbar track */
  border-radius: 6px; /* Rounded corners */
  margin: 2px; /* Padding inside the scrollbar track */
}

.custom-filter{
  position: static;
  top: 0;
  left: 0;

}

@keyframes slideDown {
  0% {
    max-height: 0;
    opacity: 0;
  }
  100% {
    max-height: 1000px; /* Adjust as needed */
    opacity: 1;
  }
}

.slide-open-down {
  animation: slideDown 0.5s ease-in-out forwards;
  display: hidden;
  /* max-height: 0; Set initial max-height to 0 */
}

.slider .thumb {
  width: 15px;
  height: 15px;
  cursor: grab;
  background: #fff;
  border-radius: 60%;
  border: 2px solid rgb(105, 76, 174);
}

.leaflet-container {
  height: 90vh;
  width: 100%;
}

.searchInput {
  width: 80%;
  padding: 10px;
  margin: 20px auto;
  display: block;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.thumbnail-container {
  /* display: flex; */
  justify-content: center;
  margin-top: 10px;
}

.thumbnail-container img {
  margin: 0 5px;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border 0.3s;
}

.thumbnail-container img:hover,
.thumbnail-container img.active {
  border: 2px solid #000;
}

.scrollable-element {
  overflow: hidden; /* Hide the scrollbar */
  overflow-y: scroll; /* Enable vertical scrolling */
  -ms-overflow-style: none; /* Hide scrollbar for Internet Explorer and Edge */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
}

.scrollable-element::-webkit-scrollbar {
  display: none; /* Hide scrollbar for Chrome, Safari, and Opera */
}

.no-select {
  -webkit-user-select: none;  /* Chrome, Safari, Opera */     /* Firefox */      /* Internet Explorer/Edge */
  user-select: none;          /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}
.react-tabs__tab-list{
  margin: 0!important;
}

#RFS-StepperContainer{
  padding: 10px 0;
}
#RFS-Label{
  margin-top: 8px;
}

`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AACA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT;;iBAEe;EACf,mCAAmC;EACnC,kCAAkC;AACpC;;EAEE,kBAAkB;;EAElB;;;;;;;;KAQG;;EAEH;;;KAGG;;;EAGH;IACE,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,cAAc;EAChB;;EAEA;IACE,gCAAgC;IAChC,WAAW;IACX,sBAAsB;IACtB,sBAAsB;IACtB,mCAAmC;IACnC,8BAA8B;EAChC;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;EACrB;;EAEA;IACE;MACE,UAAU;MACV,WAAW;MACX,4BAA4B;IAC9B;IACA;MACE,WAAW;MACX,YAAY;MACZ,6BAA6B;IAC/B;EACF;EACA;IACE;MACE,qBAAqB;MACrB,UAAU;IACZ;IACA;MACE,mBAAmB;MACnB,UAAU;IACZ;EACF;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,kBAAkB;IAClB,8CAA8C;IAC9C,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;EACE;IACE,WAAW;;EAEb;AACF;;AAEA,kBAAkB;;AAElB;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,gDAAgD;AAClD;;;AAGA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,8EAA8E;EAC9E,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;qBACqB;AACrB;EACE,qDAAqD;EACrD,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,wCAAwC,CAAC,mBAAmB;AAC9D;;AAEA;AACA,8CAA8C;AAC9C,aAAa;AACb,YAAY;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;;EAEV,wBAAwB;EACxB,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;;EAEV,wBAAwB;EACxB,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE;IACE,yBAAyB;IACzB,mCAAmC;EACrC;AACF;;;AAGA,sDAAsD;AACtD;EACE,WAAW,EAAE,2BAA2B;EACxC,YAAY,EAAE,4BAA4B;AAC5C;;AAEA;EACE,sBAAsB,EAAE,iCAAiC;EACzD,kBAAkB,EAAE,oBAAoB;EACxC,sBAAsB,EAAE,yBAAyB;AACnD;;AAEA;EACE,sBAAsB,EAAE,uBAAuB;AACjD;;AAEA;EACE,mBAAmB,EAAE,sCAAsC;EAC3D,kBAAkB,EAAE,oBAAoB;EACxC,WAAW,EAAE,uCAAuC;AACtD;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,OAAO;;AAET;;AAEA;EACE;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,kBAAkB,EAAE,qBAAqB;IACzC,UAAU;EACZ;AACF;;AAEA;EACE,8CAA8C;EAC9C,eAAe;EACf,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB,EAAE,uBAAuB;EACzC,kBAAkB,EAAE,8BAA8B;EAClD,wBAAwB,EAAE,kDAAkD;EAC5E,qBAAqB,EAAE,+BAA+B;AACxD;;AAEA;EACE,aAAa,EAAE,iDAAiD;AAClE;;AAEA;EACE,yBAAyB,GAAG,0BAA0B,MAC1B,YAAY,OACZ,2BAA2B;EACvD,iBAAiB,WAAW,iFAAiF;AAC/G;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n:root {\n  --color-primary: rgb(115, 92, 173);\n  --color-primary-input-border: #b2a6cf;\n  --color-primary-hover:#6549ac;\n  --color-primaryxxx-hover:#9080ba;\n  --color-primary-light:#f4f0ff;\n  --font-primary: \"Poppins\", sans-serif;\n}\n\n.droddown-hover-button:hover{\n  background-color: #e6defc;\n}\n\n.primary-bg{\n  background-color: var(--color-primary);\n  color: white;\n}\n.primary-text{\n  color: var(--color-primary);\n}\n.primary-bg:hover{\n  background-color: var(--color-primary-hover);\n}\n.primary-bg-common{\n  background-color: var(--color-primary-light);\n}\n\n.tab-bg-primary{\n  background-color: #e4def5;\n}\n\n\nbody {\n  font-family: \"PT Sans\", sans-serif;\n  font-weight: 400;\n  font-style: normal;\n  margin: 0;\n  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif; */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n  /* Splash screen */\n\n  /* .loader-2{\n    width : 35px;\n    height: 35px;\n    border-radius: 50%;\n    display: inline-block;\n    border-top:3px solid var(--color-primary);\n    border-right:3px solid transparent;\n    animation: rotation 1s linear infinite;\n  } */\n\n  /* @keyframes rotation {\n    0% { transform: rotate(0deg) }\n    100% { transform: rotate(360deg) }\n  } */\n\n\n  .loader{\n    width: 300px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    /* padding-top: 100px; */\n    margin: 0 auto;\n  }\n\n  .dot {\n    background: var(--color-primary);\n    margin: 5px;\n    animation-name: loader;\n    animation-duration: 1s;\n    animation-iteration-count: infinite;\n    animation-direction: alternate;\n  }\n  \n  .dot:nth-child(1) {\n    animation-delay: 0.2s;\n  }\n  .dot:nth-child(2) {\n    animation-delay: 0.4s;\n  }\n  .dot:nth-child(3) {\n    animation-delay: 0.6s;\n  }\n  .dot:nth-child(4) {\n    animation-delay: 0.8s;\n  }\n  .dot:nth-child(5) {\n    animation-delay: 1s;\n  }\n  \n  @keyframes loader {\n    from {\n      width: 2px;\n      height: 2px;\n      border-radius: calc(2px / 2);\n    }\n    to {\n      width: 10px;\n      height: 10px;\n      border-radius: calc(20px / 2);\n    }\n  }\n  @keyframes zoom-in {\n    from {\n      transform: scale(0.5);\n      opacity: 0;\n    }\n    to {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n  .modal-design{\n    position: relative;\n    padding: 0;\n    outline: none;\n    border-radius: 6px;\n    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.3);\n    background-color: #f7f7f7;\n    animation: zoom-in 0.5s ease-out;\n}\n\n@media (max-width: 450px){\n  .modal-design{\n    width: 80vw;\n    \n  }\n}\n\n/* generic Modal */\n\n.header-part{\n  border-bottom: 1.5px solid black;\n  padding-bottom: 2px;\n}\n\n/* form */\n.form-style{\n  box-shadow: 10px 2px 5px 22px rgb(212, 212, 212);\n}\n\n\n.switch-field {\n  display: flex;\n  overflow: hidden;\n}\n\n.switch-field input {\n  position: absolute !important;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  width: 1px;\n  border: 0;\n  overflow: hidden;\n}\n\n.switch-field label {\n  background-color: #e4e4e4;\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 14px;\n  line-height: 1;\n  text-align: center;\n  padding: 8px 14px;\n  margin-right: -1px;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3), 0 1px rgba(255, 255, 255, 0.1);\n  transition: all 0.1s ease-in-out;\n}\n\n.switch-field label:hover {\n  cursor: pointer;\n}\n\n.switch-field input:checked + label {\n  background-color: var(--color-primary);\n  color: white;\n  box-shadow: none;\n}\n\n.switch-field label:first-of-type {\n  border-radius: 4px 0 0 4px;\n}\n\n.switch-field label:last-of-type {\n  border-radius: 0 4px 4px 0;\n}\n\n/* input field */\n/* \n text-sm  mx-8 my-4 */\n#register input, .common-input-field, #login input, #forgotPassword input {\n  outline: 2px solid var(--color-primary-input-border) ;\n  color: rgb(59, 59, 59);\n  background-color: rgb(240, 239, 239);\n  border-radius: 5px;\n  padding: 6px 8px;\n}\n#register input:focus, .common-input-field:focus, #login input:focus, #forgotPassword input:focus{\n  outline: 2px solid var(--color-primary) ;/* Add focus ring */\n}\n\n.ReactModal__Overlay--after-open{\nbackground-color:rgba(0, 0, 0, 0.75)!important;\ndisplay: flex;\nz-index: 100;\n}\n\n.ReactModal__Content--after-open{\n  border-radius: 10px;\n}\n\n@keyframes slide-left {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.modal-menu{\n  position: relative;\n  padding: 0;\n\n  /* border-radius: 6px; */\n  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  outline: none;\n  background-color: #f7f7f7;\n  animation: slide-left 0.3s ease-out;\n}\n.cart-menu{\n  position: absolute;\n  right: 0;\n  padding: 0;\n\n  /* border-radius: 6px; */\n  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  outline: none;\n  background-color: #f7f7f7;\n  animation: slide-left 0.3s ease-out;\n}\n\n.no-scroll {\n  overflow: hidden;\n}\n\n.slick-prev:before, .slick-next:before {\n  font-size: 30px!important;\n  color: rgb(145, 145, 145)!important;\n}\n\n@media(max-width: 500px){\n  .slick-prev:before, .slick-next:before {\n    font-size: 24px!important;\n    color: rgb(145, 145, 145)!important;\n  }\n}\n\n\n/* Styles for WebKit browsers (Chrome, Safari, Edge) */\n::-webkit-scrollbar {\n  width: 12px; /* Width of the scrollbar */\n  height: 12px; /* Height of the scrollbar */\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #888; /* Color of the scrollbar thumb */\n  border-radius: 6px; /* Rounded corners */\n  border: 3px solid #fff; /* Padding around thumb */\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #555; /* Color when hovered */\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1; /* Background of the scrollbar track */\n  border-radius: 6px; /* Rounded corners */\n  margin: 2px; /* Padding inside the scrollbar track */\n}\n\n.custom-filter{\n  position: static;\n  top: 0;\n  left: 0;\n\n}\n\n@keyframes slideDown {\n  0% {\n    max-height: 0;\n    opacity: 0;\n  }\n  100% {\n    max-height: 1000px; /* Adjust as needed */\n    opacity: 1;\n  }\n}\n\n.slide-open-down {\n  animation: slideDown 0.5s ease-in-out forwards;\n  display: hidden;\n  /* max-height: 0; Set initial max-height to 0 */\n}\n\n.slider .thumb {\n  width: 15px;\n  height: 15px;\n  cursor: grab;\n  background: #fff;\n  border-radius: 60%;\n  border: 2px solid rgb(105, 76, 174);\n}\n\n.leaflet-container {\n  height: 90vh;\n  width: 100%;\n}\n\n.searchInput {\n  width: 80%;\n  padding: 10px;\n  margin: 20px auto;\n  display: block;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.thumbnail-container {\n  /* display: flex; */\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.thumbnail-container img {\n  margin: 0 5px;\n  cursor: pointer;\n  border: 2px solid transparent;\n  transition: border 0.3s;\n}\n\n.thumbnail-container img:hover,\n.thumbnail-container img.active {\n  border: 2px solid #000;\n}\n\n.scrollable-element {\n  overflow: hidden; /* Hide the scrollbar */\n  overflow-y: scroll; /* Enable vertical scrolling */\n  -ms-overflow-style: none; /* Hide scrollbar for Internet Explorer and Edge */\n  scrollbar-width: none; /* Hide scrollbar for Firefox */\n}\n\n.scrollable-element::-webkit-scrollbar {\n  display: none; /* Hide scrollbar for Chrome, Safari, and Opera */\n}\n\n.no-select {\n  -webkit-user-select: none;  /* Chrome, Safari, Opera */\n  -moz-user-select: none;     /* Firefox */\n  -ms-user-select: none;      /* Internet Explorer/Edge */\n  user-select: none;          /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */\n}\n.react-tabs__tab-list{\n  margin: 0!important;\n}\n\n#RFS-StepperContainer{\n  padding: 10px 0;\n}\n#RFS-Label{\n  margin-top: 8px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
